/* eslint-disable import/no-named-as-default */
import React, { useState, useEffect } from 'react';
import sequenceStoreData from 'Stores/sequenceData';
import { observer } from 'mobx-react-lite';
import Folders from './SequenceFolders';
import SequenceList from './SequenceList';

const AddToSequencePopup = observer(props => {
  const { closePopup, submitCbk } = props;
  const [selectedSeq, setSelectedSeq] = useState('');
  const [sequenceLoading, setSequenceLoading] = useState(true);
  const [enableConfirmButton, setEnableConfirmButton] = useState(false);

  const close = () => {
    closePopup(false);
  };

  const addToSeqAction = async () => {
    if (selectedSeq) submitCbk(selectedSeq);
  };

  useEffect(() => {
    sequenceStoreData.getAllSequenceData();
    sequenceStoreData.getAllSequenceFolders();
    return () => {
      setSequenceLoading(true);
      sequenceStoreData.setSequenceData(null);
    };
  }, []);

  return (
    <div className="sequencePopup">
      <div className="overlayMask" />
      <div className="innerWrapper popupAnimate popupScaleIn">
        <div className="popupHeader">
          <div className="sequenceTitle">Select Sequence</div>
          <div className="popup-close" title="Click here to close">
            <i className="material-icons closePopup" onClick={close}>
              close
            </i>
          </div>
        </div>
        <div className="popupBody">
          <div className="leftSection">
            <Folders setSequenceLoading={setSequenceLoading} />
          </div>
          <div className="rightSection">
            <SequenceList
              setSelectedSeq={setSelectedSeq}
              setLoading={setSequenceLoading}
              loading={sequenceLoading}
              setEnableConfirmButton={setEnableConfirmButton}
            />
          </div>
        </div>
        <div className="popupFooter">
          {enableConfirmButton && (
            <FooterButton
              enableConfirmButton={enableConfirmButton}
              addToSeqAction={addToSeqAction}
            />
          )}
        </div>
      </div>
    </div>
  );
});

const FooterButton = props => {
  const { enableConfirmButton, addToSeqAction } = props;
  return (
    <div className="buttonCont">
      <div
        className={`button confirBtn ${enableConfirmButton ? '' : 'disabled'}`}
        onClick={addToSeqAction}
      >
        Confirm
      </div>
    </div>
  );
};

export { AddToSequencePopup };
export default AddToSequencePopup;
